import { usd, frg } from './formengine/lookup.mjs';
import { FormEngine } from './formengine/index.mjs'; 
import html2canvas from 'html2canvas';

//import { PDFDocument, StandardFonts, rgb } from 'PDFLib';

const formengine = (el, pdf, options = {}) => new FormEngine(el, pdf, options);

if (window) {
    let thumbnail;
    window.getFormObject = async function () {
        const { data, formulas } = window.formEngineInstance.getData(); 
        const formulastr = formulas? JSON.stringify(formulas) :''; 
        return { 'PageList': data, 'formulas': formulastr };
        
    }
    window.getFormValues = async function () {
        var temp = window.formEngineInstance.getValues();
        return temp || []; 
    }
    window.triggerFileUpload = function (Input) {
        Input.element.click();
    };
     
    window.importPdfBytes = async function (pdfBytes, mode, savedJson, localization ) { 
        return new Promise(async (resolve, reject) => {
            try {
                const loadingTask = pdfjsLib.getDocument({ data: pdfBytes });
                const pdf = await loadingTask.promise;
                if (localization) localization = JSON.parse(localization);
                else localization = {};
                const opts = {
                    showSideBar: false,
                    editMode: mode == 'edit',
                    wrappers: {
                        container: document.getElementById('formContainer'),
                        maincontainer: document.getElementById('mainContainer'),
                        toolbarContainer: document.getElementById('toolbarContainer'),
                        editContainer: document.getElementById('editContainer'),
                        formulaContainer: document.getElementById('formulaContainer')
                    },
                    localization: localization

                }
                let parsedJson = null;
                let formulajson = null;
                if (savedJson) {
                    parsedJson = JSON.parse(savedJson);
                }
                const fe = await formengine(pdf, opts).loadData(parsedJson);
                window.formEngineInstance = fe;

                const page = await pdf.getPage(1);
                const scale = 0.3;
                const viewport = page.getViewport({ scale });

                const canvas = document.createElement('canvas');
                const context = canvas.getContext('2d', { willReadFrequently: true });
                canvas.width = viewport.width;
                canvas.height = viewport.height;
                await page.render({ canvasContext: context, viewport }).promise;
                const imgData = canvas.toDataURL('image/png');
                thumbnail = imgData.split(',')[1];

                resolve({ current: fe.currentPageIndex+1, total: fe.pageIndex-1 });

            } catch (err) {
                console.error("importPdfBytes failed", err);
                reject(err); 
            }
        });

      
        
    }
    window.setValues = async (values) => {
        var json = JSON.parse(values);
        await window.formEngineInstance.setValues(json);
    }
    window.undo = async () => { 
        await window.formEngineInstance.undo();
    }
    window.redo = async () => {
        await window.formEngineInstance.redo();
    }
    window.nextPage = async () => {
        return new Promise(async (resolve, reject) => {
            window.formEngineInstance.scrollToNextPage();
            const fe = window.formEngineInstance;
            resolve({ current: fe.currentPageIndex + 1, total: fe.pageIndex - 1 });
        });
    }
    window.prevPage = async () => { 
        return new Promise(async (resolve, reject) => {
            window.formEngineInstance.scrollToPrevPage();
            const fe = window.formEngineInstance;
            resolve({ current: fe.currentPageIndex + 1, total: fe.pageIndex - 1 });
        }); 
    }
    window.firstPage = async () => { 
        return new Promise(async (resolve, reject) => {
            window.formEngineInstance.scrollToFirstPage();
            const fe = window.formEngineInstance;
            resolve({ current: fe.currentPageIndex + 1, total: fe.pageIndex - 1 });
        });
    }
    window.lastPage = async () => { 
        return new Promise(async (resolve, reject) => {
            window.formEngineInstance.scrollToLastPage();
            const fe = window.formEngineInstance;
            resolve({ current: fe.currentPageIndex + 1, total: fe.pageIndex - 1 });
        });
    }
    window.openFormula = async () => {
        window.formEngineInstance.openFormula();
    }
    window.closeFormula = async () => {
        window.formEngineInstance.closeFormula();
    }
    window.populateLookup = async (d) => {
        var lookup = JSON.parse(d); 
        await window.formEngineInstance.populateLookup(lookup);
    }
    window.downloadPdf = async () => {
        await window.formEngineInstance.downloadPdf();
    }
    window.preventEscapeClose = ()=> {
        const windowElement = document.querySelector('.mainWindow .k-window-content');
        windowElement.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') {
                window.formEngineInstance.escapeTool();
                e.stopPropagation(); 
            }
        });
    }
}
 
window.registerFormFillInstance = function (dotNetHelper) { 
    window.formFillRef = dotNetHelper;
}
window.setDocDrag = function (d) {

}
window.snap = function (elementId) {
    return new Promise((resolve) => {
        const target = document.getElementById(elementId);
        const canvas = document.getElementById("snapCanvas");
        const ctx = canvas.getContext("2d", { willReadFrequently: true });

        html2canvas(target).then(capturedCanvas => {
            const width = capturedCanvas.width;
            const height = capturedCanvas.height;
            const imageData = capturedCanvas.getContext("2d", { willReadFrequently: true }).getImageData(0, 0, width, height).data;
             
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;

            const rect = target.getBoundingClientRect();
            const offsetX = rect.left;
            const offsetY = rect.top;

            const particles = [];

            for (let y = 0; y < height; y += 2) {
                for (let x = 0; x < width; x += 2) {
                    const index = (y * width + x) * 4;
                    const r = imageData[index];
                    const g = imageData[index + 1];
                    const b = imageData[index + 2];
                    const a = imageData[index + 3];

                    if (a > 0) {
                        particles.push({
                            x: x + offsetX,
                            y: y + offsetY,
                            dx: (Math.random() - 0.5) * 5,
                            dy: (Math.random() - 0.5) * 5,
                            life: 1,
                            color: `rgba(${r},${g},${b},${a / 255})`
                        });
                    }
                }
            }
             
            target.style.visibility = "hidden";

            function animate() {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                let alive = false;

                particles.forEach(p => {
                    p.x += p.dx;
                    p.y += p.dy;
                    p.life -= 0.01;
                    if (p.life > 0) {
                        alive = true;
                        ctx.fillStyle = p.color;
                        ctx.globalAlpha = p.life;
                        ctx.fillRect(p.x, p.y, 2, 2);
                    }
                });

                ctx.globalAlpha = 1;

                if (alive) {
                    requestAnimationFrame(animate);
                } else {
                    resolve(); 
                }
            }

            animate();
        });
    });
};



  
   